import LocationSection from "./LocationSection";
import {useContext, useRef, useState} from "react";
import {MapContext} from "../context/MapContext";
import ActionButton from "./ActionButton";
import {Filter, Grid, UnorderedList} from "reicon-react";

const LocationList = ({locations, collapsed = false}) => {
  const input = useRef()
  const [isSearchFocused, setIsSearchFocused] = useState(false)
  const [isContentScrolled, setIsContentScrolled] = useState(false)
  const {listLayout, setListLayout, setShowSettings, searchFilter, setSearchFilter} = useContext(MapContext)
  const types = ['Escenarios', 'Servicios', 'Accesos', 'Zonas']
  const filteredLocations = locations.filter(element => element.name.toLowerCase().includes(searchFilter.toLowerCase()))

  return (
    <section className="location-list">
      <header className={`header${isSearchFocused ? ' search-focused' : ''}${!collapsed && isContentScrolled ? ' content-scrolled' : ''}`}>
        <div className="search-field">
          <input
            className="search-input"
            value={searchFilter}
            onChange={e => setSearchFilter(e.target.value)}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
            ref={input}
            type="search"
            placeholder="Buscar"/>
        </div>
        <div
          className="layout-tabs"
          data-layout={listLayout}
          role="group"
          aria-label="Formato de visualización">
          <button
            type="button"
            className={listLayout === 'list' ? 'active' : ''}
            aria-pressed={listLayout === 'list'}
            onClick={() => setListLayout('list')}>
            <UnorderedList size={18} strokeWidth={1.75}/>
            <span>Lista</span>
          </button>
          <button
            type="button"
            className={listLayout === 'grid' ? 'active' : ''}
            aria-pressed={listLayout === 'grid'}
            onClick={() => setListLayout('grid')}>
            <Grid size={18} strokeWidth={1.75}/>
            <span>Cuadrícula</span>
          </button>
        </div>
        <ActionButton
          className="panel-action-button"
          icon={Filter}
          label="Abrir filtros"
          onClick={() => setShowSettings(true)}
        />
      </header>
      {!collapsed && <div className="scroll" onScroll={event => setIsContentScrolled(event.currentTarget.scrollTop > 0)}>
          {types.map(type => (
            <LocationSection
              key={type}
              data={filteredLocations}
              type={type}
              layout={listLayout}
            />
          ))}
        </div>}
    </section>
  );
};

export default LocationList;
